import styles from './styles.module.css';
import InstagramIcon from './instagram.svg';
import FacebookIcon from './facebook.svg';
import YoutubeIcon from './youtube.svg';
import LinkedInIcon from './linkedin.svg'
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function Footer() {
    const strapiData:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.WebappHomepageV22?.WebappHomepageV22?.SocialMediaLinksOnFooter);
    const {instagramUrl, facebookUrl, youtubeUrl, linkedInUrl} = useMemo(()=>{
        const instagramUrl = strapiData?.find(x=>x?.Title?.toLowerCase() === "instagram")?.Link;
        const facebookUrl = strapiData?.find(x=>x?.Title?.toLowerCase() === "facebook")?.Link;
        const youtubeUrl = strapiData?.find(x=>x?.Title?.toLowerCase() === "youtube")?.Link;
        const linkedInUrl = strapiData?.find(x=>x?.Title?.toLowerCase() === "linkedin")?.Link;
        return {instagramUrl, facebookUrl, youtubeUrl, linkedInUrl};
    },[strapiData])
    return <div className={styles.container}>
        <div className={styles.linksContainer}>
            {linksList.map(item=><Link name={item.title} href={item.href} />)}
        </div>
        <div className={styles.socialMedia}>
            <SocialMediaItem SVG={InstagramIcon} href={instagramUrl} />
            <SocialMediaItem SVG={FacebookIcon} href={facebookUrl} />
            <SocialMediaItem SVG={YoutubeIcon} href={youtubeUrl} />
            <SocialMediaItem SVG={LinkedInIcon} href={linkedInUrl} />
        </div>
    </div>
}

const Link = ({name, href}) => {
    return <div className={styles.link}>
        <a href={href} target='_blank'>{name}</a>
    </div>
}

const SocialMediaItem = ({ SVG , href }) => {
    return <a href={href} target='_blank'><SVG /></a>
}

const linksList = [{
    title: "About",
    href: "https://www.domyshoot.com/about-us/[locale]"
},{
    title: "Terms and Conditions",
    href:'https://www.domyshoot.com/terms-of-service'
},{
    title: "Privacy Policy",
    href:"https://www.domyshoot.com/privacy-policy",
},{
    title: "Blogs",
    href:"https://www.domyshoot.com/blog",
},{
    title: "Tutorials",
    href:"https://www.domyshoot.com/tutorial"
},{
    title: "FAQS",
    href: "https://www.domyshoot.com/faq"
}]